import React from "react"
import parse from "html-react-parser"
import { graphql } from "gatsby"
import { Asset, Link } from "../../../../plugins/gatsby-plugin-atollon"
import StructuredText from "../custom-structured-text-renderer"
import AnimationButton from "./animation-button"
import { useKeenSlider } from "keen-slider/react"

const SunnysideQuality = ({ title, items, gallery, richContent, button }) => {
  const animation = { duration: 30000, easing: (t) => t }
  const [sliderRef] = useKeenSlider({
    loop: true,
    renderMode: "performance",
    drag: false,
    slides: {
      perView: 1.35,
    },
    breakpoints: {
      "(min-width: 768px)": {
        slides: {
          perView: 2.5,
        },
      },
      "(min-width: 1024px)": {
        slides: {
          perView: 3.5,
        },
      },
      "(min-width: 1440px)": {
        slides: {
          perView: 3.5,
        },
      },
    },
    created(s) {
      s.moveToIdx(5, true, animation)
    },
    updated(s) {
      s.moveToIdx(s.track.details.abs + 5, true, animation)
    },
    animationEnded(s) {
      s.moveToIdx(s.track.details.abs + 5, true, animation)
    },
  })

  return (
    <section className="sunnyside-quality">
      <div className="sunnyside-quality__inner">
        <div className="sunnyside-quality__title">
          {title && <h2>{parse(title)}</h2>}
        </div>

        <div className="sunnyside-quality__items">
          {items?.length > 0 &&
            items.map((el, i) => (
              <div className="sunnyside-quality__item" key={i}>
                <div className="sunnyside-quality__item-content">
                  {el.label && <p>{parse(el.label)}</p>}
                </div>
                <div className="sunnyside-quality__item-icon">
                  {el.icon && <Asset asset={el.icon} />}
                </div>
              </div>
            ))}
        </div>

        {gallery?.length > 0 &&

          <div
            className="sunnyside-quality__image keen-slider"
            ref={sliderRef}
          >
            {gallery?.length > 0 &&
              gallery.map((el, i) => (
                <div
                  className="sunnyside-quality__image-item keen-slider__slide"
                  key={i}
                >
                  <Asset asset={el} />
                </div>
              ))}
              {gallery?.length > 0 &&
              gallery.map((el, i) => (
                <div
                  className="sunnyside-quality__image-item keen-slider__slide"
                  key={i}
                >
                  <Asset asset={el} />
                </div>
              ))}
          </div>
        }

        <div className="sunnyside-quality__content">
          {richContent && <StructuredText data={richContent} />}
          {button?.length > 0 && (
            <AnimationButton
              className="btn btn--animation"
              to={
                button[0].link[0].externalLink
                  ? button[0].link[0].externalLink
                  : button[0].link[0].internalLink?.permalink
              }
            >
              {button[0].title}
            </AnimationButton>
          )}
        </div>
      </div>
    </section>
  )
}

export default SunnysideQuality

export const query = graphql`
  fragment SunnysideQualityProps on DatoCmsSunnysideQuality {
    ... on DatoCmsSunnysideQuality {
      id
      title
      items {
        label
        icon {
          ...InternalAssetProps
        }
      }
      gallery {
        ...InternalAssetProps
      }
      richContent {
        value
      }
      button {
        ...LinkWithTitleProps
      }
    }
  }
`
